import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'fc-data-card-v2',
  templateUrl: './fc-data-card-v2.component.html',
  styleUrls: ['./fc-data-card-v2.component.scss']
})
export class FcDataCardV2Component {

  @Input() value = 0;
  @Input() label = '';
  @Input() description = '';
  @Input() color = '';
  @Input() backgroundColor = '';
  @Input() icon = '';
  @Input() loading = false;

  constructor() {}
}
